import { memo, FC } from "react";
import { Link, Td, Tr, Badge } from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";

type Props = {
  name: string;
  eventsRuleName: string;
  schedule?: string;
  state?: string;
  parampath: string;
  onClick: (parampath: string) => void;
};

export const TenantJobRow: FC<Props> = memo((props) => {
  const {
    name,
    eventsRuleName,
    schedule,
    state,
    parampath,
    onClick,
  } = props;

  return (
    <Tr key={parampath} bg="gray.50">
      <Td>
        <Link onClick={() => onClick(parampath)} isExternal>
          {name}
          <EditIcon mx="2" color={"gray"} fontSize="sm" />
        </Link>
      </Td>
      <Td fontFamily="mono" fontSize="sm">{schedule || "-"}</Td>
      <Td>
        {eventsRuleName === "manual" ? (
          <Badge colorScheme="orange">手動</Badge>
        ) : state === "DISABLED" ? (
          <Badge colorScheme="red">無効</Badge>
        ) : state === "ENABLED" ? (
          <Badge colorScheme="green">有効</Badge>
        ) : (
          <Badge colorScheme="gray">-</Badge>
        )}
      </Td>
    </Tr>
  );
});
